export class SliderModel {
  constructor (
    public id: string,
    public title: string,
    public slide: Object[] = []
  ) {}
}
